import BigNumber from "bignumber.js";

export const chargingPowerTwoDecimal = power => {
  return new BigNumber(power).toFixed(2);
};
